module.exports = __webpack_public_path__ + "static/img/kd100_seckill_bg.9d66c4f1.png";